import PasswordProtected from './passwordProtected.ui';

export default PasswordProtected;
